import React from 'react';

function WhiteHeader() {
    return (
        <div className="w-full h-16 bg-white z-10 top-0 p-3 shadow-md fixed">
        </div>
    );
}

export default WhiteHeader;